/**
 * Печатает запись в отдельном окне браузера.
 *
 * Используется как дефолтное поведение печати строки из таблицы.
 * Если в компоненте передан собственный обработчик onPrint, следует вызывать его вместо этой функции.
 *
 * @param tableName Название таблицы/сущности (используется в заголовке печати)
 * @param record Объект записи, который нужно вывести на печать
 */
export function printRecord(tableName: string | undefined, record: Record<string, unknown>): void {
  const html = `
    <html>
      <head>
        <title>Print Record - ${tableName || 'Repository Table'}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .header { border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; }
          .field { margin-bottom: 10px; }
          .field-label { font-weight: bold; color: #333; }
          .field-value { margin-left: 10px; }
          .null-value { color: #999; font-style: italic; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>📊 ${tableName || 'Repository Table'}</h1>
          <p>Record Details - Generated on ${new Date().toLocaleString()}</p>
        </div>
        <div class="content">
          ${Object.entries(record)
            .map(
              ([key, value]) => `
              <div class="field">
                <span class="field-label">${key}:</span>
                <span class="field-value ${value === null || value === undefined ? 'null-value' : ''}">
                  ${
                    value === null || value === undefined
                      ? 'N/A'
                      : typeof value === 'object'
                        ? escapeHtml(JSON.stringify(value, null, 2))
                        : escapeHtml(String(value))
                  }
                </span>
              </div>
            `
            )
            .join('')}
        </div>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }
}

/**
 * Простейшее экранирование HTML для безопасного вывода значений.
 */
function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
